//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name:'HRAR',
  data() {
    return {
      form:{
        duration:'',
        number:'',
        inpatient:'',
      },
      defaultJson:{
        "Inpatient treatments for alcoholism": "因酗酒而住院治疗",
        "Daily drinks": "每日饮酒次数",
        "Prior treatments": "既往治疗次数",
        "1 drink = 12 g of ethanol": "1 次饮酒 = 12 g 乙醇摄入",
        "Low risk of relapse": "再酗酒低危",
        "High risk of relapse": "再酗酒高危",
        "Duration of drinking (yr)": "饮酒史（年）"
      },
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:"0",name:'≤10'},
        {value:"1",name:'11-25'},
        {value:"2",name:'≥26'},
      ],
      dataList2:[
        {value:"0",name:'≤8'},
        {value:"1",name:'9-17'},
        {value:"2",name:'≥18'},

      ],
      dataList3:[
        {value:"0",name:'0'},
        {value:"1",name:'1'},
        {value:"2",name:'≥2'},

      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // duration + number + inpatient
        let result = form.duration + form.number + form.inpatient
        console.log(result,'result----------------');
        self.hasScore = true
        return String(result)
      }
    }
  },

}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/HRAR.vue